
// VehicleModel services rest api calling

import { routes } from '../config/api_routes'

export const vehicleModelServices = {

    // get VehicleModel 
    // info: sortDesc : Boolean
    
    getVehicleModel: (formData) => window.axios.post(routes.getVehicleModelApi,formData),

    // add VehicleModel Type 

    addVehicleModel: (formData) => window.axios.post(routes.addVehicleModelApi,formData),

    // get VehicleModelById 

    getVehicleModelById: (formData) => window.axios.post(routes.getVehicleModelApiById,formData),

    // update VehicleModelById

    updateVehicleModelById: (formData) => window.axios.post(routes.updateVehicleModelApi,formData),

    // delete VehicleModelById

    deleteVehicleModelById: (formData) => window.axios.post(routes.deleteVehicleModelApi,formData),


    //add model colour
    addVehicleModelColour: (formData) => window.axios.post(routes.addVehicleModelColourApi,formData),

    //remove model colour
    removeVehicleModelColour: (formData) => window.axios.post(routes.removeVehicleModelColourApi,formData),
}